/**
 * Sistema de Resenas de Productos
 * Tienda de Calzado Deportivo - Colombia
 * Custom Element: product-reviews
 */

class ProductReviews extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.storageKey = `productReviews_v4_${this.productId}`;
    this.reviews = [];
    this.visibleCount = 5;
  }

  connectedCallback() {
    this.productInfo = {
      title: this.dataset.productTitle || '',
      vendor: this.dataset.productVendor || '',
      type: this.dataset.productType || '',
      material: this.dataset.productMaterial || '',
      calidad: this.dataset.productCalidad || '',
      suela: this.dataset.productSuela || '',
      uso: this.dataset.productUso || '',
      tags: (this.dataset.productTags || '').split(',').filter(Boolean)
    };

    this.cacheElements();
    this.loadReviews();
    this.bindEvents();
    this.render();
  }

  cacheElements() {
    this.reviewsList = this.querySelector('[data-reviews-list]');
    this.loadMoreBtn = this.querySelector('[data-load-more]');
    this.form = this.querySelector('[data-review-form]');
    this.starSelector = this.querySelector('[data-star-selector]');
    this.ratingInput = this.querySelector('[data-rating-input]');
    this.ratingError = this.querySelector('[data-rating-error]');
    this.successMessage = this.querySelector('[data-success-message]');
    this.starsDisplay = this.querySelector('[data-stars]');
    this.averageText = this.querySelector('[data-average-text]');
    this.progressFill = this.querySelector('[data-progress-fill]');
    this.starButtons = this.querySelectorAll('.product-reviews__star');
  }

  bindEvents() {
    this.starButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => this.handleStarClick(e));
      btn.addEventListener('mouseenter', (e) => this.handleStarHover(e));
    });
    this.starSelector.addEventListener('mouseleave', () => this.resetStarDisplay());
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    this.loadMoreBtn.querySelector('button').addEventListener('click', () => this.showMoreReviews());
  }

  loadReviews() {
    var stored = localStorage.getItem(this.storageKey);
    if (stored) {
      try {
        this.reviews = JSON.parse(stored);
      } catch (e) {
        this.reviews = [];
      }
    }
    if (this.reviews.length === 0) {
      this.reviews = this.generateDemoReviews();
      this.saveReviews();
    }
    this.sortReviews();
  }

  /**
   * Seeded random para consistencia por producto
   */
  seededRandom(seed) {
    var x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  }

  /**
   * Genera hash numerico simple del product ID
   */
  hashProductId() {
    var hash = 0;
    var str = String(this.productId);
    for (var i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash = hash & hash;
    }
    return Math.abs(hash);
  }

  /**
   * Detecta si es producto de mujer, hombre o unisex
   */
  detectGender() {
    var title = this.productInfo.title.toLowerCase();
    var tags = this.productInfo.tags.map(function(t) { return t.toLowerCase(); });
    var type = this.productInfo.type.toLowerCase();
    var all = title + ' ' + tags.join(' ') + ' ' + type;

    if (all.match(/mujer|dama|women|woman|femenin|her|ladies|she/)) return 'mujer';
    if (all.match(/hombre|caballero|men|masculin|him|his/)) return 'hombre';
    if (all.match(/ni[nñ]o|kid|junior|infant|beb[eé]/)) return 'nino';
    return 'unisex';
  }

  generateDemoReviews() {
    var now = Date.now();
    var day = 86400000;
    var hash = this.hashProductId();
    var gender = this.detectGender();
    var self = this;

    var nombresMujer = [
      'Valentina R.', 'Camila S.', 'Isabella M.', 'Mariana L.', 'Sofia G.',
      'Laura P.', 'Daniela V.', 'Natalia C.', 'Andrea F.', 'Carolina H.',
      'Juliana T.', 'Alejandra B.', 'Paula A.', 'Gabriela D.', 'Luisa K.',
      'Maria Jose O.', 'Sara E.', 'Angela N.', 'Diana Q.', 'Catalina J.'
    ];

    var nombresHombre = [
      'Carlos M.', 'Andres R.', 'Sebastian P.', 'Santiago L.', 'Juan D.',
      'David G.', 'Felipe H.', 'Nicolas V.', 'Alejandro S.', 'Miguel A.',
      'Daniel F.', 'Mateo C.', 'Camilo T.', 'Jorge B.', 'Diego E.',
      'Esteban K.', 'Pablo O.', 'Ricardo N.', 'Fernando Q.', 'Cristian J.'
    ];

    var ciudades = [
      'Bogota', 'Medellin', 'Cali', 'Barranquilla', 'Cartagena',
      'Bucaramanga', 'Pereira', 'Manizales', 'Cucuta', 'Ibague',
      'Santa Marta', 'Villavicencio', 'Pasto', 'Neiva', 'Armenia'
    ];

    // Seleccionar pool de nombres segun genero
    var nombresPrimarios, nombresSecundarios;
    if (gender === 'mujer') {
      nombresPrimarios = nombresMujer;
      nombresSecundarios = nombresHombre;
    } else if (gender === 'hombre') {
      nombresPrimarios = nombresHombre;
      nombresSecundarios = nombresMujer;
    } else {
      nombresPrimarios = nombresHombre.concat(nombresMujer);
      nombresSecundarios = nombresPrimarios;
    }

    var productName = this.productInfo.title;
    var vendor = this.productInfo.vendor;
    var material = this.productInfo.material;
    var calidad = this.productInfo.calidad;
    var suela = this.productInfo.suela;
    var uso = this.productInfo.uso;

    var templates5stars = [
      { title: 'Llegaron perfectos', body: 'Pedi los {producto} y llegaron en excelente estado a {ciudad}. La calidad se nota desde que los sacas de la caja.' },
      { title: 'Me encantaron', body: 'Son tal cual se ven en las fotos. Muy comodos desde el primer uso. Los recomiendo totalmente.' },
      { title: 'Super comodos', body: 'Llevo usandolos todos los dias y siguen como nuevos. La comodidad es increible, no me los quiero quitar.' },
      { title: 'Excelente compra', body: 'Primera vez que compro en Level Sport y quede muy satisfecho. El envio fue rapido y el producto es exactamente lo que esperaba.' },
      { title: 'Los mejores que he tenido', body: 'He comprado varios pares de {vendor} y estos son de los mejores. Se sienten premium y se ven espectaculares.' },
      { title: 'Totalmente recomendados', body: 'Un amigo me recomendo Level Sport y no me arrepiento. Los {producto} son una chimba, muy buena calidad.' },
      { title: 'Increible relacion calidad-precio', body: 'Por el precio que pague, la calidad es impresionante. Superaron mis expectativas. Ya quiero pedir otro par.' },
      { title: 'Envio rapido a {ciudad}', body: 'Los pedi un lunes y el jueves ya los tenia. Llegaron bien empacados y el producto es tal cual la foto.' },
      { title: 'Pague contra entrega y todo bien', body: 'Me daba miedo comprar por internet pero el pago contra entrega me dio confianza. Los {producto} son espectaculares.' },
      { title: 'Mi tercer par de Level Sport', body: 'Ya es la tercera vez que compro aca y siempre quedan bien. El {producto} quedo perfecto para el dia a dia.' },
      { title: 'Para regalo y quedo encantado', body: 'Se los regale a mi pareja y le fascinaron. La caja llego en perfecto estado. Muy buena presentacion.' },
      { title: 'Tal cual las fotos', body: 'Tenia dudas de comprar online pero los {producto} llegaron identicos a las fotos. Muy buena experiencia con Level Sport.' },
      { title: 'Muy contentos en casa', body: 'Le pedi a mi hermano que me los comprara y quedamos ambos contentos. Los {producto} son una belleza.' },
      { title: 'De lo mejor que he comprado', body: 'Tengo varios pares de diferentes tiendas online y estos de Level Sport son de los que mas me gustan. Excelente acabado.' },
      { title: 'Se los recomende a todos', body: 'Desde que llegaron los {producto} no paro de recomendarlos. Ya tres amigos pidieron en Level Sport tambien.' },
      { title: 'Llegaron antes de lo esperado', body: 'Pensaba que tardarian mas pero llegaron a {ciudad} super rapido. El producto esta perfecto, muy satisfecho.' },
      { title: 'Mejor de lo que esperaba', body: 'Sinceramente no esperaba tanta calidad por el precio. Los {producto} quedaron brutales, ya estoy mirando otro par.' },
      { title: 'No me los quiero quitar', body: 'Desde que llegaron los uso para todo. Son super comodos y combinan con cualquier outfit. Feliz con la compra.' },
      { title: 'Compra segura', body: 'El pago contra entrega es una ventaja enorme. Pude revisar el producto antes de pagar y todo salio perfecto.' },
      { title: 'Se ven increibles', body: 'Todos me preguntan donde los compre. Los {producto} se ven mucho mejor en persona que en la foto. 10/10.' },
      { title: 'Repetire compra seguro', body: 'Quede tan contento con los {producto} que ya estoy mirando otro modelo. Level Sport se gano un cliente fiel.' },
      { title: 'Justo lo que necesitaba', body: 'Buscaba unos {vendor} a buen precio y estos superaron lo que esperaba. Muy comodos y el envio llego perfecto a {ciudad}.' },
      { title: 'Excelente atencion', body: 'Tuve una duda antes de comprar y me respondieron super rapido. Los {producto} llegaron tal cual me dijeron. Todo perfecto.' },
      { title: 'Mi novia los ama', body: 'Se los compre a mi novia y no se los ha quitado desde que llegaron. Dice que son los mas comodos que ha tenido.' },
      { title: 'Buena inversion', body: 'Llevo mas de un mes usandolos y siguen como nuevos. Por el precio que pague son una excelente inversion.' }
    ];

    var templates4stars = [
      { title: 'Buenos pero la talla fue justa', body: 'Los {producto} son buenos. La talla quedo un poco justa, recomiendo pedir media talla mas. De resto excelente calidad.' },
      { title: 'Buen producto, envio demorado', body: 'La calidad del producto esta bien. El envio tardo un poco mas de lo esperado a {ciudad} pero llegaron en buen estado.' },
      { title: 'Me gustaron mucho', body: 'Cumplen con lo que prometen. El color es un poquito diferente a la foto pero igual se ven muy bien puestos.' },
      { title: 'Buena compra en general', body: 'Comodos y bonitos. Solo les quito una estrella porque el empaque llego un poco maltratado, pero el producto perfecto.' },
      { title: 'Bien por el precio', body: 'Para lo que cuestan estan muy bien. Para uso diario cumplen perfecto, los uso casi todos los dias.' },
      { title: 'Comodos pero calurosos', body: 'Los {producto} son comodos y se ven bien. Lo unico es que en clima caliente se siente un poco el calor. De resto todo bien.' },
      { title: 'Lindos pero tarde en llegar', body: 'El producto en si esta muy bien, pero el envio a {ciudad} tardo mas de lo que esperaba. El producto si vale la pena.' },
      { title: 'Quedan grandes', body: 'Me parecen muy bonitos y comodos, pero me quedaron un poco grandes. Tocaria pedir media talla menos. La calidad si esta buena.' }
    ];

    var templates5starsMaterial = [
      { title: 'Material de primera', body: 'Se nota que el {material} es de buena calidad. Llevo semanas usandolos y no se han desgastado nada. Super resistentes.' },
      { title: 'Calidad del material excelente', body: 'El {material} se siente muy bien al tacto. Comodos y el acabado es impecable. Valen cada peso.' },
      { title: 'El material sorprende', body: 'No esperaba que el {material} fuera tan bueno. Se siente firme y al mismo tiempo comodo. Muy bien logrado.' }
    ];

    var templates5starsCalidad = [
      { title: 'Calidad {calidad} impecable', body: 'Son calidad {calidad} y se ven identicos al modelo original. Muy buena elaboracion en cada detalle.' },
      { title: 'Impresionado con la calidad', body: 'Para ser calidad {calidad} el acabado es increible. Se ven y se sienten como si fueran mucho mas caros.' },
      { title: 'No se nota la diferencia', body: 'Calidad {calidad} y honestamente se ven espectaculares. Un amigo tiene los originales y no se nota diferencia.' }
    ];

    var templates5starsSuela = [
      { title: 'Suela muy comoda', body: 'La suela {suela} es super comoda para caminar. Paso muchas horas de pie y no me canso. Muy buena amortiguacion.' },
      { title: 'Aguantan todo el dia', body: 'Trabajo de pie todo el dia y con la suela {suela} llego a casa sin dolor. Eso para mi vale oro.' }
    ];

    var templates5starsUso = [
      { title: 'Perfectos para {uso}', body: 'Los compre especificamente para {uso} y cumplen al 100%. Comodidad y estilo, justo lo que necesitaba.' },
      { title: 'Ideales para lo que buscaba', body: 'Queria unos tenis para {uso} y estos {producto} son perfectos. Muy comodos y se ven geniales.' },
      { title: 'Los uso para {uso} y van de 10', body: 'Desde que los compre los uso siempre para {uso}. Aguantan todo y se mantienen como nuevos.' }
    ];

    // Construir pool de templates
    var pool5 = templates5stars.slice();
    var pool4 = templates4stars.slice();

    if (material) {
      pool5 = pool5.concat(templates5starsMaterial);
    }
    if (calidad) {
      pool5 = pool5.concat(templates5starsCalidad);
    }
    if (suela) {
      pool5 = pool5.concat(templates5starsSuela);
    }
    if (uso) {
      pool5 = pool5.concat(templates5starsUso);
    }

    function replacePlaceholders(text) {
      return text
        .replace(/\{producto\}/g, productName)
        .replace(/\{vendor\}/g, vendor || 'esta marca')
        .replace(/\{material\}/g, (material || 'el material').toLowerCase())
        .replace(/\{calidad\}/g, (calidad || '').toLowerCase())
        .replace(/\{suela\}/g, (suela || 'la suela').toLowerCase())
        .replace(/\{uso\}/g, (uso || 'uso diario').toLowerCase());
    }

    // Cantidad variable por producto: entre 15 y 24, usando hash
    var minReviews = 15;
    var maxReviews = 24;
    var targetTotal = minReviews + (hash % (maxReviews - minReviews + 1));

    // Limitar al pool disponible para NUNCA repetir
    var max5 = pool5.length;
    var max4 = pool4.length;
    // Aprox 1 de cada 4 es de 4 estrellas
    var desired4 = Math.min(Math.floor(targetTotal / 4), max4);
    var desired5 = Math.min(targetTotal - desired4, max5);
    var totalReviews = desired5 + desired4;

    var reviews = [];
    var usedNames = {};

    // Mezclar pools con seed para que el orden varie por producto
    function shuffleWithSeed(arr, s) {
      var a = arr.slice();
      for (var j = a.length - 1; j > 0; j--) {
        var k = Math.floor(self.seededRandom(s + j * 13) * (j + 1));
        var tmp = a[j]; a[j] = a[k]; a[k] = tmp;
      }
      return a;
    }

    var shuffled5 = shuffleWithSeed(pool5, hash + 1);
    var shuffled4 = shuffleWithSeed(pool4, hash + 2);

    // Construir lista intercalada: cada 4ta resena es de 4 estrellas
    var idx5 = 0;
    var idx4 = 0;
    var templateList = [];
    for (var i = 0; i < totalReviews; i++) {
      if ((i + 1) % 4 === 0 && idx4 < shuffled4.length) {
        templateList.push({ t: shuffled4[idx4], r: 4 });
        idx4++;
      } else if (idx5 < shuffled5.length) {
        templateList.push({ t: shuffled5[idx5], r: 5 });
        idx5++;
      } else if (idx4 < shuffled4.length) {
        templateList.push({ t: shuffled4[idx4], r: 4 });
        idx4++;
      }
    }

    for (var i = 0; i < templateList.length; i++) {
      var seed = hash + i * 7 + 1;
      var entry = templateList[i];

      // Nombre: 70% del genero principal, 30% secundario
      var usePrimary = self.seededRandom(seed + 300) > 0.3;
      var namePool = usePrimary ? nombresPrimarios : nombresSecundarios;
      var nameIdx = Math.floor(self.seededRandom(seed + 400) * namePool.length);
      var attemptsN = 0;
      while (usedNames[namePool[nameIdx]] && attemptsN < namePool.length) {
        nameIdx = (nameIdx + 1) % namePool.length;
        attemptsN++;
      }
      var authorName = namePool[nameIdx];
      usedNames[authorName] = true;

      // Ciudad
      var cityIdx = Math.floor(self.seededRandom(seed + 500) * ciudades.length);
      var city = ciudades[cityIdx];

      // Fecha: distribuida entre hace 2 dias y hace 6 meses
      var daysAgo = 2 + Math.floor(self.seededRandom(seed + 600) * 180);
      var reviewDate = now - (daysAgo * day);

      var titleText = replacePlaceholders(entry.t.title).replace(/\{ciudad\}/g, city);
      var bodyText = replacePlaceholders(entry.t.body).replace(/\{ciudad\}/g, city);

      reviews.push({
        id: 'demo_v3_' + self.productId + '_' + i,
        rating: entry.r,
        title: titleText,
        body: bodyText,
        author: authorName,
        email: authorName.toLowerCase().replace(/[^a-z]/g, '') + '@mail.com',
        date: reviewDate,
        verified: true
      });
    }

    return reviews;
  }

  generateId() {
    return 'review_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  sortReviews() {
    this.reviews.sort(function(a, b) { return b.date - a.date; });
  }

  saveReviews() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.reviews));
  }

  calculateAverage() {
    if (this.reviews.length === 0) return 0;
    var sum = this.reviews.reduce(function(acc, review) { return acc + review.rating; }, 0);
    return (sum / this.reviews.length).toFixed(1);
  }

  formatRelativeDate(timestamp) {
    var now = Date.now();
    var diff = now - timestamp;
    var minute = 60000;
    var hour = 3600000;
    var day = 86400000;
    var week = 604800000;
    var month = 2592000000;
    var year = 31536000000;

    if (diff < minute) return 'hace un momento';
    if (diff < hour) {
      var mins = Math.floor(diff / minute);
      return 'hace ' + mins + (mins === 1 ? ' minuto' : ' minutos');
    }
    if (diff < day) {
      var hours = Math.floor(diff / hour);
      return 'hace ' + hours + (hours === 1 ? ' hora' : ' horas');
    }
    if (diff < week) {
      var days = Math.floor(diff / day);
      return 'hace ' + days + (days === 1 ? ' dia' : ' dias');
    }
    if (diff < month) {
      var weeks = Math.floor(diff / week);
      return 'hace ' + weeks + (weeks === 1 ? ' semana' : ' semanas');
    }
    if (diff < year) {
      var months = Math.floor(diff / month);
      return 'hace ' + months + (months === 1 ? ' mes' : ' meses');
    }
    var years = Math.floor(diff / year);
    return 'hace ' + years + (years === 1 ? ' ano' : ' anos');
  }

  handleStarClick(event) {
    var rating = parseInt(event.currentTarget.dataset.rating);
    this.ratingInput.value = rating;
    this.updateStarDisplay(rating, true);
    this.ratingError.classList.add('hidden');
  }

  handleStarHover(event) {
    var rating = parseInt(event.currentTarget.dataset.rating);
    this.updateStarDisplay(rating, false);
  }

  resetStarDisplay() {
    var selectedRating = parseInt(this.ratingInput.value);
    this.updateStarDisplay(selectedRating, true);
  }

  updateStarDisplay(rating, isSelected) {
    this.starButtons.forEach(function(btn, index) {
      if (index < rating) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    var rating = parseInt(this.ratingInput.value);
    if (rating < 1) {
      this.ratingError.classList.remove('hidden');
      return;
    }
    var formData = new FormData(this.form);
    var newReview = {
      id: this.generateId(),
      rating: rating,
      title: formData.get('title').trim(),
      body: formData.get('body').trim(),
      author: formData.get('author').trim(),
      email: formData.get('email').trim(),
      date: Date.now(),
      verified: false
    };
    this.reviews.unshift(newReview);
    this.saveReviews();
    this.form.reset();
    this.ratingInput.value = 0;
    this.updateStarDisplay(0, true);
    this.successMessage.classList.remove('hidden');
    var msg = this.successMessage;
    setTimeout(function() { msg.classList.add('hidden'); }, 5000);
    this.visibleCount = 5;
    this.render();
    this.reviewsList.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  showMoreReviews() {
    this.visibleCount += 5;
    this.render();
  }

  render() {
    this.renderSummary();
    this.renderReviews();
    this.updateLoadMoreButton();
  }

  renderSummary() {
    var average = this.calculateAverage();
    var totalReviews = this.reviews.length;
    var percentageFill = (average / 5) * 100;
    var ratingWhole = Math.floor(average);
    var ratingDecimal = average - ratingWhole;
    this.starsDisplay.style.setProperty('--rating', ratingWhole);
    this.starsDisplay.style.setProperty('--rating-decimal', ratingDecimal.toFixed(2));
    this.averageText.textContent = average + '/5 (' + totalReviews + (totalReviews === 1 ? ' resena)' : ' resenas)');
    this.progressFill.style.width = percentageFill + '%';
  }

  renderReviews() {
    if (this.reviews.length === 0) {
      this.reviewsList.innerHTML = '<div class="product-reviews__empty"><div class="product-reviews__empty-icon">\u2606</div><p>Aun no hay resenas para este producto.</p><p>Se el primero en compartir tu opinion!</p></div>';
      return;
    }
    var reviewsToShow = this.reviews.slice(0, this.visibleCount);
    var self = this;
    this.reviewsList.innerHTML = reviewsToShow.map(function(review) { return self.renderReviewItem(review); }).join('');
  }

  renderReviewItem(review) {
    var ratingWhole = Math.floor(review.rating);
    var ratingDecimal = review.rating - ratingWhole;
    var relativeDate = this.formatRelativeDate(review.date);
    var verifiedBadge = review.verified
      ? '<span class="product-reviews__verified"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> Compra verificada</span>'
      : '';

    return '<article class="product-reviews__item">' +
      '<header class="product-reviews__item-header">' +
        '<span class="product-reviews__item-stars rating-star" style="--rating: ' + ratingWhole + '; --rating-max: 5; --rating-decimal: ' + ratingDecimal.toFixed(2) + ';"></span>' +
        '<span class="product-reviews__item-date">' + relativeDate + '</span>' +
      '</header>' +
      '<h5 class="product-reviews__item-title">' + this.escapeHtml(review.title) + '</h5>' +
      '<p class="product-reviews__item-body">' + this.escapeHtml(review.body) + '</p>' +
      '<footer class="product-reviews__item-footer">' +
        '<span class="product-reviews__item-author">' + this.escapeHtml(review.author) + '</span>' +
        verifiedBadge +
      '</footer>' +
    '</article>';
  }

  updateLoadMoreButton() {
    if (this.reviews.length > this.visibleCount) {
      this.loadMoreBtn.classList.remove('hidden');
      var remaining = this.reviews.length - this.visibleCount;
      this.loadMoreBtn.querySelector('button').textContent = 'Ver mas resenas (' + remaining + ' mas)';
    } else {
      this.loadMoreBtn.classList.add('hidden');
    }
  }

  escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

if (!customElements.get('product-reviews')) {
  customElements.define('product-reviews', ProductReviews);
}
